let apiHost = "/ext/";

if (process.env.DEBUG) {
  apiHost = ["localhost", "pc.my"].includes(window.location.hostname) ? "https://erdr-dash.ftband.com/ext/" : "/ext/";
}

export function getOrganizations() {
  return fetch(apiHost + "catalog/organizations").then(response => response.json());
}

const filterEmpty = obj => Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));

export function getChartData(page, organizations, {
  from,
  to,
  period,
  articles
}) {
  if (articles && articles.length === 0 || articles.length === 1 && articles[0] === "") articles = undefined;
  return fetch(apiHost + "chart-data/" + page, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(filterEmpty({
      organizations: organizations,
      from,
      to,
      period,
      articles
    }))
  }).then(response => response.json());
}